import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import moment from 'moment'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import TagsFilter from '../../../components/fields/TagsFilter'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import withOrganization from 'App/Decorators/withOrganization'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'
import SignersStatus from '../Common/SignersStatus'
import MdCancel from 'react-icons/lib/md/cancel'

@withOrganization
@withRouter
@withMessage
@withMutation(gql`
  mutation rejectedDocument($documentId: ID) {
    rejectedDocument(documentId: $documentId) {
      success
    }
  }
`)
export default class RejectedDocuments extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    rejectedDocument: PropTypes.func,
    organization: PropTypes.object,
    showMessage: PropTypes.func
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/documents/${_id}`)
  }

  getFields() {
    if (isMobile()) {
      return [
        {
          title: '',
          name: 'documentStatus{status}',
          render: ({documentStatus}) => this.renderIcon(documentStatus)
        },
        {title: 'Nombre', name: 'name'},
        {
          title: '',
          name: ' ',
          render: item => this.renderActions(item)
        }
      ]
    }
    return [
      {
        title: '',
        name: 'documentStatus{status}',
        render: ({documentStatus}) => this.renderIcon(documentStatus)
      },
      {title: 'Nombre', name: 'name'},
      {
        title: 'Firmas',
        name: 'signersStatus{email, didSign}, feasStatus{email, didSign}, biosStatus{email, didSign}, faceStatus{email, didSign}' ,
        render: ({signersStatus, feasStatus, biosStatus, faceStatus}) =>
          SignersStatus(signersStatus, feasStatus, biosStatus, faceStatus)
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm')
      },
      {
        title: 'Razón del rechazo',
        name: 'rejected.reason',
      },
    ]
  }

  async rejectedDocument(item) {
    try {
      await this.props.rejectedDocument(
        {
          documentId: item._id
        },
        {
          refetchQueries: ['documentCount', 'organizationDocCount']
        }
      )
      this.props.showMessage('Documento restaurado')
    } catch (e) {
    } finally {
      this.refs.paginated.reload()
    }
  }

  renderIcon() {
      return (
        <div>
          <Tooltip content="El documento ha sido rechazado">
            <MdCancel size={20} style={{ color: '#FF0000' }} />
          </Tooltip>
        </div>
      )
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              headRightComponent={TagsFilter}
              queryName="rejectedDocuments"
              defaultLimit={25}
              fields={this.getFields()}
              ref="paginated"
              params="$filter: String $tags: [String] $organization: String"
              organization={this.props.organization._id}
              onPress={this.onSelect}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/RejectedDocuments/index.js